// extracted by mini-css-extract-plugin
module.exports = {"cancel-button":"CancelButton_cancel-button__QHkQK"};